import { useForm } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import { useTranslation } from "react-i18next";
import {
  emailChangeSchema,
  shownFieldError,
} from "../../../../utils/validationPatterns";
import { useEffect, useState } from "react";
import { CustomButton } from "../../../atoms/CustomButton";
import { Modal } from "flowbite-react";
import { CustomInput } from "../../../atoms/CustomInput";
import { useLmcUserView } from "../../../../contexts/AuthContext";
import { useUpdateUserEmail } from "../../../../hooks/users";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { AuthActionKind } from "../../../../contexts/AuthContext";

const ProfileEmailChange = () => {
  const { t } = useTranslation("clientView");

  const {
    state: { entity, auth },
  } = useLmcUserView();

  const [show, setShow] = useState(false);

  const { mutate: updateEmail, isLoading } = useUpdateUserEmail();

  const { dispatch } = useLmcUserView();
  const navigate = useNavigate();
  const params = useParams();
  const {
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    control,
  } = useForm({
    resolver: joiResolver(emailChangeSchema),
    defaultValues: {
      user_email: auth.profile.email,
      new_user_email: "",
      new_user_email_confirmation: "",
    },
  });

  const onSubmit = (values: any) => {
    let authPayload = {
      username: "",
      password: "",
    };
    authPayload.username = auth.user_identification as string;
    authPayload.password = auth.access_token as string;

    updateEmail(
      {
        user_identification: auth?.user_identification,
        entity_identification: entity?.entity_data?.entity_identification,
        data: values,
        authorization: authPayload,
      },
      {
        onSuccess: () => {
          toast.success(t("register.confirmEmailModal.text_2"));
          dispatch({
            type: AuthActionKind.LOGOUT,
            payload: null,
          });
          navigate(`/loyalty-program/${params.processId}/login`, {
            replace: true,
          });
        },
      }
    );
  };

  useEffect(() => {
    reset({ user_email: auth.profile.email });
  }, [reset, setValue, auth]);

  useEffect(() => {}, []);
  return (
    <div className="w-full px-5 pt-5 pb-8 rounded-lg shadow-sm flex flex-col justify-start items-start gap-5">
      <div className="self-stretch flex-col justify-start items-start gap-2 flex">
        <div className="text-gray-200 text-lg font-semibold font-figtree leading-7">
          {t("dashboard.profile.key5")}
        </div>
        <div className="text-gray-200 text-sm font-normal font-figtree leading-tight break-words">
          {t("dashboard.profile.key6")}
        </div>
      </div>

      <div className="w-full flex items-center gap-3 flex-wrap">
        <div className="w-full justify-start items-start gap-5 flex">
          <div className="w-full flex-col justify-start items-start flex">
            <div className="w-full py-2 px-3 bg-white rounded-md shadow-sm border border-gray-300 justify-start items-center flex">
              <div className="text-gray-700 text-sm font-normal font-figtree leading-tight break-all">
                {auth.profile.email}
              </div>
            </div>
          </div>
        </div>

        <CustomButton
          variant="outline"
          type="submit"
          onClick={() => setShow(true)}
          title={t("dashboard.profile.key13")}
        />
      </div>

      <Modal show={show} onClose={() => setShow(false)} size={"md"}>
        <Modal.Header className="border-b-0  bg-gray-800">
          <div className=" text-gray-200">{t("dashboard.profile.key7")}</div>
        </Modal.Header>
        <Modal.Body className=" bg-gray-800">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-5">
              <CustomInput
                name="user_email"
                label={
                  t("dashboard.userProfile.changeEmailForm.label-01") as string
                }
                className="shadow-sm"
                control={control}
                type="email"
                error={errors.user_email}
                disabled
                helperText={shownFieldError(t, errors.user_email?.message)}
                labelClassName="text-sm font-medium text-gray-200"
                inputDir="ltr"
              />
            </div>

            <div className="mb-5">
              <CustomInput
                name="new_user_email"
                label={
                  t("dashboard.userProfile.changeEmailForm.label-02") as string
                }
                className="shadow-sm"
                error={errors.new_user_email}
                helperText={shownFieldError(t, errors.new_user_email?.message)}
                type="email"
                control={control}
                labelClassName="text-sm font-medium text-gray-200"
                inputDir="ltr"
              />
            </div>

            <div className="mb-5">
              <CustomInput
                name="new_user_email_confirmation"
                control={control}
                label={
                  t("dashboard.userProfile.changeEmailForm.label-03") as string
                }
                className="shadow-sm"
                type="email"
                error={errors.new_user_email_confirmation}
                helperText={shownFieldError(
                  t,
                  errors.new_user_email_confirmation?.message
                )}
                labelClassName="text-sm font-medium text-gray-200"
                inputDir="ltr"
              />
            </div>

            <div className="flex items-center justify-around gap-4">
              <CustomButton
                className="w-1/2"
                onClick={() => setShow(false)}
                title={t("common.cancel")}
              />

              <CustomButton
                type="submit"
                variant="primary"
                className="w-1/2"
                disabled={isLoading}
                isLoading={isLoading}
                title={t("common.update")}
              />
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ProfileEmailChange;
